

export const CustomerSelectModal = ({customers, onSelect}) =>
{
  return (<>
    <p className="message blue">搜尋結果有多於一位顧客，請選擇。</p>
    <table className="data-table tbl-custsel">
      <colgroup>
        <col with="40px" id="col-custsel-btn" />
        <col with="auto" id="col-custsel-id" />
        <col with="auto" id="col-custsel-name" />
        <col with="200px" id="col-custsel-license" />
        <col with="auto" id="col-custsel-remarks" />
      </colgroup>
      <thead>
        <tr>
          <th></th>
          <th>客戶編號</th>
          <th>客戶名稱</th>
          <th>名下車輛</th>
          <th>備註</th>
        </tr>
      </thead>
      <tbody>
      { customers.map(c =>
        <tr key={c.id}>
          <td className="col-custsel-btn">
            <button className="btn small grey" onClick={e=>onSelect(c)}>選擇</button>
          </td>
          <td className="col-custsel-id">{ c.id }</td>
          <td className="col-custsel-name">{ c.display_name }</td>
          <td className="col-custsel-name">
          { c.vehicles?.map(v =>
            <span key={v.cd_license} className="tag license">{ v.cd_license }</span>
          )}
          </td>
          <td className="col-custsel-remarks">{ c.remarks }</td>
        </tr>
      )}
      </tbody>
    </table>
  </>);
}

export default CustomerSelectModal;